import * as Types from '../../../api';

import { gql } from '@apollo/client';
export type IvrListFragment = { __typename?: 'Ivr', name: string, numberId: number, number?: { __typename?: 'Number', shortNumber?: string | null, e164?: any | null } | null };

export const IvrListFragmentDoc = gql`
    fragment IvrList on Ivr {
  number {
    shortNumber
    e164
  }
  name
  numberId
}
    `;